import AuthedAPI from "api/AuthedAPI";
import RequestOptions from "api/RequestOptions";
import EmojiInterface from "api/models/EmojiInterface";
import { useCityConfig } from "city/cityConfig";
import { useMemo } from "react";

export function useImageStorageAPI() {
  const config = useCityConfig();
  return useMemo(
    () =>
      new AuthedAPI({
        baseUrl: config.IMAGESTORAGE_URL,
        isWithoutHeader: true,
      }),
    [config.IMAGESTORAGE_URL],
  );
}
export function getEmojiData() {
  const api = useImageStorageAPI();
  return (options?: RequestOptions) =>
    api.getJson<EmojiInterface[]>({
      options,
      queryParams: {},
      path: "emoji/icon_options.json",
    });
}
